import {saveMessarioLaunchToken} from '@lib/messarioLaunch/token';

export const MESSARIO_LAUNCH_FRAGMENT = 'messario_launch';

export type MessarioLaunchFragment = {
  token?: string,
  invalid: boolean
};

export function captureMessarioLaunchFragment(
  locationValue: Pick<Location, 'hash' | 'pathname' | 'search'> = window.location,
  replaceState: History['replaceState'] = window.history.replaceState.bind(window.history),
  storage: Storage | undefined = window.sessionStorage
): MessarioLaunchFragment {
  const prefix = `#${MESSARIO_LAUNCH_FRAGMENT}=`;
  if(!locationValue.hash.startsWith(prefix)) {
    return {invalid: false};
  }

  const encodedToken = locationValue.hash.slice(prefix.length);
  let token: string | undefined;
  let invalid = !encodedToken;
  if(encodedToken) {
    try {
      token = decodeURIComponent(encodedToken) || undefined;
      invalid = !token;
    } catch(err) {
      invalid = true;
    }
  }

  // Persist BEFORE the fragment leaves the URL: a reload between here and the panel resolve
  // (service worker unregister/reload, `swfix`) must still be able to pick the token up.
  if(token && storage) {
    try {
      saveMessarioLaunchToken(token, storage);
    } catch(err) {
      // storage unavailable (quota / privacy mode) — fall back to the in-memory token only
    }
  }

  replaceState(null, '', `${locationValue.pathname}${locationValue.search}`);

  return invalid ? {invalid: true} : {token, invalid: false};
}
